export default __webpack_public_path__ + "static/media/projectRes10.ced63af9.jpg";